export {};
export const TELEGRAM_SUBDOMAIN_SUFFIX = '-twa';

export const detectIsTelegramMiniApp = (host?: string | null) => {
  if (!host) return false;

  const subdomain = host.split('.')[0];
  if (subdomain && subdomain.endsWith(TELEGRAM_SUBDOMAIN_SUFFIX)) {
    return true;
  }
  return false;
};

